import { Box, Typography, Tooltip } from '@mui/material';
import { useWorkstreamTypes } from './hooks/useWorkstreamTypes';
import { useWorkspaceContext } from './context/WorkspaceContext';

export const Legend: React.FC = () => {
  const { workspaceId } = useWorkspaceContext();
  const { workstreamTypes } = useWorkstreamTypes(workspaceId);

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        alignItems: 'center',
        gap: 3,
        mb: 3,
        px: 1
      }}
    >
      <Typography 
        variant="subtitle2" 
        sx={{ 
          fontWeight: 500,
          minWidth: 'fit-content'
        }}
      >
        Workstream Types:
      </Typography>
      
      <Box 
        sx={{ 
          display: 'flex', 
          gap: 2,
          flexWrap: 'wrap'
        }}
      >
        {workstreamTypes.map((type) => (
          <Tooltip key={type.id} title={type.label}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                cursor: 'default',
                '&:hover': {
                  opacity: 0.8
                }
              }}
            >
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  borderRadius: 1,
                  backgroundColor: type.color,
                  transition: 'transform 0.2s ease',
                  '&:hover': {
                    transform: 'scale(1.2)'
                  }
                }}
              />
              <Typography 
                variant="body2" 
                sx={{ 
                  color: 'text.secondary',
                  fontSize: '0.875rem'
                }}
              >
                {type.label}
              </Typography>
            </Box>
          </Tooltip>
        ))}
      </Box>
    </Box>
  );
};